export const getModOfDelivery = (mod: string , list: { shippingInformation: string; MOD: string; }[]) => {
    let deliveryMod: string = "";
    list.forEach((items: { shippingInformation: string; MOD: string; }) => {
        if(items.shippingInformation?.trim()?.toLowerCase() === mod?.trim()?.toLowerCase()) {
            deliveryMod = items?.MOD;
        }
    });
    return deliveryMod;
};
